import { render, staticRenderFns } from "./WorkTogetherComponent.vue?vue&type=template&id=70a34b04&scoped=true&"
import script from "./WorkTogetherComponent.vue?vue&type=script&lang=js&"
export * from "./WorkTogetherComponent.vue?vue&type=script&lang=js&"
import style0 from "./WorkTogetherComponent.vue?vue&type=style&index=0&id=70a34b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a34b04",
  null
  
)

export default component.exports